export default "__VITE_ASSET__D1J92Vn0__"